/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedServiceLocationSeoFieldsAdmin } from './PaginatedServiceLocationSeoFieldsAdmin'
import {
  PaginatedServiceLocationSeoFieldsAdminFromJSON,
  PaginatedServiceLocationSeoFieldsAdminFromJSONTyped,
  PaginatedServiceLocationSeoFieldsAdminToJSON,
} from './PaginatedServiceLocationSeoFieldsAdmin'

/**
 *
 * @export
 * @interface EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin
 */
export interface EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin {
  /**
   *
   * @type {PaginatedServiceLocationSeoFieldsAdmin}
   * @memberof EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin
   */
  body: PaginatedServiceLocationSeoFieldsAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin interface.
 */
export function instanceOfEnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdminFromJSON(
  json: any,
): EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin {
  return EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdminFromJSONTyped(
    json,
    false,
  )
}

export function EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedServiceLocationSeoFieldsAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdminToJSON(
  value?: EnvelopedServiceLocationSeoFieldsListServiceLocationSeoFieldsAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedServiceLocationSeoFieldsAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
